import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { HeaderConfigService, OnDestroyBase } from '@os-components';
import { Labels } from '@sew/ui-components';
import { SewWsReader } from '@sew/ui-components-angular/standalone';
import { takeUntil } from 'rxjs';
import { Content } from '../../../../models/blog-posts.model';

@Component({
    selector: 'blog-audio',
    templateUrl: './audio.component.html',
    styleUrls: ['./audio.component.scss'],
    imports: [CommonModule, SewWsReader],
})
export class AudioComponent extends OnDestroyBase implements OnInit {
    @Input() public audio?: Content;
    public labels?: Labels;

    public constructor(private configService: HeaderConfigService) {
        super();
    }

    public ngOnInit(): void {
        this.configService.labelsChange
            .pipe(takeUntil(this.destroySubject))
            .subscribe((labels) => (this.labels = labels));
    }
}
